/**
 * 保存状态标签组件
 */

import React from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, SyncOutlined, CloseCircleOutlined } from '@ant-design/icons';
import type { SaveStatus } from '../hooks/useAutoSave';

interface SaveStatusTagProps {
    status: SaveStatus;
}

export const SaveStatusTag: React.FC<SaveStatusTagProps> = ({ status }) => {
    switch (status) {
        case 'saved':
            return (
                <Tag icon={<CheckCircleOutlined />} color="success" style={{ borderRadius: 12 }}>
                    已保存
                </Tag>
            );
        case 'saving':
            return (
                <Tag icon={<SyncOutlined spin />} color="processing" style={{ borderRadius: 12 }}>
                    保存中...
                </Tag>
            );
        case 'error':
            return (
                <Tag icon={<CloseCircleOutlined />} color="error" style={{ borderRadius: 12 }}>
                    保存失败
                </Tag>
            );
        default:
            return null;
    }
};
